import logo from './logo.svg';
import './App.css';
import "./styles/Home.css";
import "./styles/tablet.css";
import "./styles/largeTablet.css";
import "./styles/laptop.css";
import "./styles/desktop.css";
import './styles/light.css';
import './styles/dark.css';

import NavBar from './components/NavBar';
import Footer from './components/Footer'; 
import DashboardLayout from './components/DashboardLayout';
import Home from './screens/Home';
import Login from './screens/Login';
import Pricing from './screens/Pricing';
import Products from './screens/Products';
import Resources from './screens/Resources';
import Solutions from './screens/Solutions';
import DataPurchase from './screens/DataPurchase';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import Register from './screens/Register';
import Dashboard from './screens/Dashboard';
import Transactions from './screens/Transactions';
import Wallet from './screens/Wallet';
import GlobalLoading from "./components/GlobalLoading";
import { useState, useEffect } from "react";
import ProtectedRoute from './components/ProtectedRoute'; // Import ProtectedRoute
import LiveChatWidget from './components/LiveChatWidget';
import ErrorFallback from './components/ErrorFallBack';
import ErrorBoundary from './components/ErrorBoundary';
import BuyAirtime from './screens/BuyAirtime';
import BankAccount from './screens/BankAccount';
import Settings from './screens/Settings';
import ProfileSettings from './screens/ProfileSettings';
import GeneralSettings from './screens/GeneralSettings';
import SecuritySettings from './screens/SecuritySettings';
import Help from './screens/Help';
import Contact from './screens/Contact/Contact';
import Faq from './screens/Contact/Faq';
import Report from './screens/Contact/Report';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Don't forget to import styles
import CableTV from './screens/CableTv';
import RechargeCard from './screens/RechargeCard';
import GeneratedPins from './screens/GeneratedPins';
import Education from './screens/Education';
import EducationDetails from './screens/EducationDetails';
import ElectricityDetails from './screens/ElectricityDetails';
import ElectricityPayment from './screens/ElectricityPayment';
import AirtimeToCash from './screens/AirtimeToCash';
import BulkSms from './screens/BulkSms';
import CableDetails from './screens/CableDetails';
import BuySmartData from './screens/BuySmartData';
import SelectPaymentMethod from './screens/SelectPaymentMethod';
import VirtualAccountPayment from './screens/VirtualAccountPayment';
import PayStackPayment from './screens/PayStackPayment';
import Withdraw from './screens/Withdraw';
import AddBankAccount from './screens/AddBankAccount';
import TransactDesign from './screens/TransactDesign';
import TransactDetails from './screens/TransactDetails';
import VerifyAccount from './screens/VerifyAccount';
import Review from './screens/Review';
import ReceiptPage from './screens/ReceiptPage';
import ForgotPassword from './screens/ForgotPassword';
import VerifyPassword from './screens/VerifyPassword';
import ForgotPin from './screens/ForgotPin';

const Layout = () => {
  return (
    <>
      <NavBar />
      <Outlet />
      <Footer />
    </>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
    // Simulate loading or fetch auth token etc.
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 1500); // delay for inspection

    return () => clearTimeout(timeout);
  }, []);
  const myrouter = createBrowserRouter([
    {
      path: '/',
      element: <Layout />,
      children: [
        { path: '/', element: <Home /> },
        { path: '/pricing', element: <Pricing /> },
        { path: '/products', element: <Products /> },
        { path: '/resources', element: <Resources /> },
        { path: '/solutions', element: <Solutions /> },
      ],
    },

     // ❌ Move login/register out of Layout
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/register',
    element: <Register />
  },

     { path: "/verify-account", element: <VerifyAccount /> },
     
     { path: "/forgot-password", element: <ForgotPassword /> },

      { path: "/verify-password", element: <VerifyPassword /> },

  
    // Protect Dashboard routes
    {
      path: "",
      element: <ProtectedRoute />,  // Protect all child routes
      children: [
        {
          path: "",
          element: <DashboardLayout />,
          children: [
            { path: "/dashboard", element: <Dashboard /> },
            { path: "/transactions", element: <TransactDesign /> },
            { path: "/transactions/:id", element: <TransactDetails /> },
         
            { path: "/wallet", element: <Wallet /> },
            {path: "/review", element: <Review />},
             {path: "/receipt", element: <ReceiptPage />},
            {path: "/buy-data", element: <BuySmartData/>},
            { path: "/buy-airtime", element: <BuyAirtime /> }, 
            {path: "/bank-account", element: <BankAccount/>},
            {path: "/add-bank-account", element: <AddBankAccount/>},
            { path: "/forgot-pin", element: <ForgotPin /> },
            {path: "/buy-cabletv", element: <CableTV/>},
            {path: "/recharge-card-printing", element: <RechargeCard/>},
            {path: "/generated-pins", element: <GeneratedPins/>}, 
            {path: "/result-checker", element: <Education/>},  
            {path: "/result-details", element: <EducationDetails/>}, 
            {path: "/electricity-details", element: <ElectricityDetails/>},
            {path: "/cable-tv-subscriptions", element: <CableDetails/>}, 
            {path: "/bills-payment", element: <ElectricityPayment/>},
            {path: "/airtime-to-cash", element: <AirtimeToCash/>},
            {path: "/bulk-sms", element: <BulkSms/>},
            {path: "/add-funds", element: <SelectPaymentMethod/>},
            {path: "/virtual-pay", element: <VirtualAccountPayment/>},
            {path: "/paystack-pay", element: <PayStackPayment/>},
            {path: "/withdraw", element: <Withdraw/>},
            
         
            {
              path: '/settings',
              element: <Settings />, // Parent settings page
              children: [
                { path: 'profile', element: <ProfileSettings /> },
                { path: 'general', element: <GeneralSettings /> },
                { path: 'security', element: <SecuritySettings /> },
              ],
            },

            {
              path: '/help',
              element: <Help />, // Parent settings page toast
              children: [
                { path: 'contact', element: <Contact /> },
                { path: 'faq', element: <Faq /> },
                { path: 'report', element: <Report /> },
              ],
            },
           
          ],
        }, 
      ],
    },
  ]);
 
  return (
    <div>
         {isLoading && <GlobalLoading />} {/* ✅ Fullscreen overlay */}
       <LiveChatWidget /> {/* ✅ Mount chat widget globally */}
       <ErrorBoundary fallback={<ErrorFallback/>}> 
        <RouterProvider router={myrouter} />
      </ErrorBoundary>
      <ToastContainer />
    </div>
  );
}

export default App;
